import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class PostPassengerBlockedDriversCommand extends IRequestCommand<
IPostPassengerFavoriteBlockedDriversResponse,
  ErrorDetails,
  IPostPassengerFavoriteBlockedDriversCommandParameters
> {


  public override setParameters(parameters: IPostPassengerFavoriteBlockedDriversCommandParameters) {
   this._commandType = CommandRequestType.POST;
   this._commandUrl = `passengers/${parameters.passengerId}/blockedDrivers`;
    this._commandBody = {carrierId: parameters.carrierId, driverIds: parameters.driverIds};
  }
}

export class PostPassengerFavoriteDriversCommand extends IRequestCommand<
  IPostPassengerFavoriteBlockedDriversResponse,
  ErrorDetails,
  IPostPassengerFavoriteBlockedDriversCommandParameters> {
  public override setParameters(parameters: IPostPassengerFavoriteBlockedDriversCommandParameters) {
   this._commandType = CommandRequestType.POST;
   this._commandUrl = `passengers/${parameters.passengerId}/favoriteDrivers`;
    this._commandBody = {carrierId: parameters.carrierId, driverIds: parameters.driverIds};
  }
}

export interface IPostPassengerFavoriteBlockedDriversCommandParameters extends ICommandParameters {
  passengerId?: number,
  carrierId: number,

  //VER COMO SE LLAMA, ACA PUSE UNO MA O MENO
  driverIds: number[]
}

export interface IPostPassengerFavoriteBlockedDriversResponse extends ICommandResponse {}
